/**
 * 服务器配置工具
 * 自动识别当前访问的服务器IP和端口
 */

/**
 * 获取当前页面的IP地址
 * @returns {string} 当前页面的IP地址
 */
export function getCurrentBaseUrl() {
  return window.location.hostname;
}

/**
 * 获取管理员登录URL
 * @returns {string} 管理员登录URL
 */
export function getAdminLoginUrl() {
  const ip = getCurrentBaseUrl();
  return `http://${ip}:8080/jnAdmin/lg/jl`;
}

/**
 * 获取API服务器URL
 * @returns {string} API服务器URL
 */
export function getApiServerUrl() {
  const ip = getCurrentBaseUrl();
  // 使用Nginx代理后，不需要指定端口号
  return `http://${ip}/declare`;
}

/**
 * 获取专技服务器URL
 * @returns {string} 专技服务器URL
 */
export function getTechServerUrl() {
  const ip = getCurrentBaseUrl();
  return `http://${ip}`;
}

/**
 * 检测是否为开发环境
 * @returns {boolean} 是否为开发环境
 */
export function isDevelopment() {
  return process.env.NODE_ENV === 'development';
}

/**
 * 检测是否为生产环境
 * @returns {boolean} 是否为生产环境
 */
export function isProduction() {
  return process.env.NODE_ENV === 'production';
}

/**
 * 根据环境获取服务器配置
 * @returns {Object} 服务器配置对象
 */
export function getServerConfig() {
  const isDev = isDevelopment();

  if (isDev) {
    // 开发环境使用固定配置
    return {
      serverUrl: "https://api.zcjnzx.com/declare",
      adminLoginUrl: "http://39.101.244.20:8084/jnAdmin/lg/jl",
      techServerUrl: "https://api.zcyunzj.com"
    };
  } else {
    // 生产环境使用动态配置
    return {
      serverUrl: "https://api.zcjnzx.com/declare",
      adminLoginUrl: "http://39.101.244.20:8084/jnAdmin/lg/jl",
      techServerUrl: "https://api.zcyunzj.com"
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/serverConfig.js